import { QueryFactory } from "../../../../Common";
export const QGetGames = QueryFactory("GetGames");
//# sourceMappingURL=QGetGames.js.map